import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import PigmentRemoval from './components/PigmentRemoval';
import ContactPage from './pages/ContactPage';
import EquipmentPage from './pages/EquipmentPage';

import SingleMachinePage from './pages/SingleMachinePage';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} >
        <Route path="/services/:serviceId" element={<PigmentRemoval />} />
        </Route>

        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact"  element={<ContactPage/>} />
        <Route path="/equipment" element={<EquipmentPage/>} />

        <Route path="/service/:serviceId/section/:sectionId" element={<SingleMachinePage/>} />

        
      </Routes>
    </Router>
  );
};

export default AppRoutes;
